import React, { useState } from 'react'
import { Box, Button, TextField, Typography } from '@mui/material'
import DrawerNav from '../Navigation/DrawerNav'
import { BASE_URL } from '../../Api/constants'
import { useLocation, useNavigate } from 'react-router-dom'

function useQuery() {
    return new URLSearchParams(useLocation().search)
}

export default function AddExam() {
    const [name, setName] = useState('')
    const [description, setDescription] = useState('')
    const [imageURL, setImageURL] = useState('')
    const navigate = useNavigate()
    const query = useQuery()
    const subjectID = query.get('subjectID')
    const topicID = query.get('topicID')
    const subjectName = query.get('subjectName')
    const topicName = query.get('topicName')

    const handleSaveChanges = async () => {
        try {
            const response = await fetch(`${BASE_URL}/api/admin/v1/exam`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    subjectID,
                    topicID,
                    name,
                    description,
                    imageURL
                })
            })

            const data = await response.json()

            if (response.ok) {
                setName('')
                setDescription('')
                navigate(-1)
            } else {
                console.error(data.message)
            }
        } catch (error) {
            console.error('Error:', error)
        }
    }

    return (
        <Box sx={{ display: 'flex' }}>
            <DrawerNav />
            <Box component='main' sx={{ flexGrow: 1, p: 3 }}>
                <Box p={2}>
                    <Typography variant='h4' sx={{ my: 2, fontWeight: 'bolder', color: '#4b4848' }}>
                        Add New Quiz
                    </Typography>
                    <TextField label='Subject' disabled value={subjectName} fullWidth variant='outlined' margin='normal' />
                    <TextField label='Topic' disabled value={topicName} fullWidth variant='outlined' margin='normal' />
                    <TextField label='Quiz Name' value={name} onChange={(event) => setName(event.target.value)} fullWidth variant='outlined' margin='normal' />
                    <TextField label='Quiz Description' value={description} onChange={(event) => setDescription(event.target.value)} fullWidth variant='outlined' margin='normal' />
                    <TextField label='Quiz Image' value={imageURL} onChange={(event) => setImageURL(event.target.value)} fullWidth variant='outlined' margin='normal' />
                    <Box mt={2}>
                        <Button variant='contained' color='success' onClick={handleSaveChanges}>
                            Add Quiz
                        </Button>
                    </Box>
                </Box>
            </Box>
        </Box>
    )
}
